import { StreamActions, visit } from "@hotwired/turbo";

StreamActions.redirect = function() {
  visit(this.getAttribute("target") as string);
};
